import { Component, OnInit } from '@angular/core'; 
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { CompaniesService } from 'src/app/services/yardscore-services/companies.service';

@Component({
  selector: 'app-companies-edit-v2',
  templateUrl: './companies-edit-v2.component.html',
  styleUrls: ['./companies-edit-v2.component.css']
})
export class CompaniesEditV2Component implements OnInit {
  companiesForm: FormGroup;
  isSubmitting = false;
  errors: any = {};  
  companyId!: number;
  vesselCreditsUsed = 0; 
  vesselsTotal = 0;

  constructor(
    private companyService: CompaniesService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.companiesForm = this.fb.group({
      name: ['', Validators.required],
      vatNumber: ['', Validators.required],
      type: ['', Validators.required], 
      credits: this.fb.group({
        calculations: [0, Validators.required],
        validations: [0, Validators.required],
        engineeringAssistance: [0, Validators.required],
        vessels: [{ value: 0}] 
      })
    });
  }

  ngOnInit(): void {
    this.companyId = Number(this.route.snapshot.paramMap.get('id'));
    if (this.companyId) {
      this.loadCompany();
    }
  }

  loadCompany(): void {
    this.companyService.getCompanyByIdV2(this.companyId).subscribe(
      (data) => {
        this.vesselCreditsUsed = data.credits?.vessels?.used || 0;
  
        const vesselsTotal = data.credits?.vessels?.total || 0;
  
        this.companiesForm.patchValue({
          name: data.name,
          vatNumber: data.vatNumber,
          type: data.type || '',
          credits: {
            calculations: data.credits?.calculations?.total || 0,
            validations: data.credits?.validations?.total || 0,
            engineeringAssistance: data.credits?.engineeringAssistance?.total || 0,
            vessels: vesselsTotal
          }
        });
  
        this.vesselsTotal = vesselsTotal;  
      },
      (error) => {
        this.toastr.error('Failed to load company.');
      }
    );
  }
  
  

  updateCompany(): void {
    if (this.isSubmitting) return;
  
    this.isSubmitting = true;
  
    const formData = this.companiesForm.getRawValue();
  
    const updatedCompany = {
      name: formData.name,
      vatNumber: formData.vatNumber,
      type: formData.type,
      credits: {
        calculations: {
          total: formData.credits.calculations,
          used: 0,
          isAllowed: formData.credits.calculations > 0
        },
        validations: {
          total: formData.credits.validations,
          used: 0,
          isAllowed: formData.credits.validations > 0
        },
        engineeringAssistance: {
          total: formData.credits.engineeringAssistance,
          used: 0,
          isAllowed: formData.credits.engineeringAssistance > 0
        },
        vessels: {
          total: formData.credits.vessels,
          used: 0, 
          isAllowed: formData.credits.vessels > 0
        }
      }
    };
  
    this.companyService.editCompanyV2(this.companyId, updatedCompany).pipe(
      catchError(error => {
        this.errors = {};
  
        if (error.status === 400) {
          if (Array.isArray(error.error)) {
            error.error.forEach((errMessage: string) => {
              if (errMessage.includes('Name')) {
                this.errors.name = this.errors.name || [];
                this.errors.name.push(errMessage);
              } else if (errMessage.includes('VatNumber')) {
                this.errors.vatNumber = this.errors.vatNumber || [];
                this.errors.vatNumber.push(errMessage);
              } else if (errMessage.includes('Type')) {
                this.errors.type = this.errors.type || [];
                this.errors.type.push(errMessage);
              } else {
                this.errors.general = this.errors.general || [];
                this.errors.general.push(errMessage);
              }
            });
          } else if (typeof error.error === 'string') {
            this.errors.general = [error.error];
          } else {
            this.toastr.error('An unexpected error occurred.');
          }
        } else {
          this.toastr.error('Failed to update company.');
        }
        return [];
      })
    ).subscribe(
      response => {
        this.toastr.success('Company updated successfully!');
        this.router.navigate(['/homeAdmin/v2/companies']);
      },
      error => {
        console.error('Error updating company:', error);
      }
    ).add(() => {
      this.isSubmitting = false;
    });
  }
}
